var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoRealityChecks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tick_2_",
    "data-name": "tick (2)",
    d: "M.717,9.763A1.028,1.028,0,0,0,.83,11.22l5.135,4.373a1.038,1.038,0,0,0,.676.249c.031,0,.062,0,.093,0a1.039,1.039,0,0,0,.713-.374L16.23,4.845a1.03,1.03,0,0,0-.144-1.456L14.478,2.076a1.047,1.047,0,0,0-1.464.143L6.255,10.393,3.538,8.081a1.048,1.048,0,0,0-1.467.112Z",
    transform: "translate(-.466 -1.842)",
    fill: "#74276b"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoRealityChecks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_reality_checks.3fbf7dace9ea99f7ce2ea78c2b4e3e6c.svg";